import React, { useEffect, useRef, useState } from "react";
import { Button } from "./ui";
import CustomDropdown from "./dropdown/CustomDropdown";
import FilterDropdown from "./dropdown/FilterDropdown";
import SortDropdown from "./dropdown/SortDropdown";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ItemsPerPageDropdown from "./dropdown/ItemsPerPageDropdown";
import ViewToggleDropdown from "./ListGridToggle";
import { useTranslation } from "react-i18next";
import CustomDateRangePicker, { LocalizedDateInput } from "./DatePicker";
import "./ui/filterbar.css";

const Toolbar = ({
  showBranchDropdown = false,
  branchWithAllOption = false,
  showPlatformDropdown = false,
  showDropDown2 = false,
  showSearch = false,
  showDateFilter = false,
  showDateRange = false,
  showFilter = false,
  showSort = false,
  showViewMode = false,
  showButton1 = false,
  showButton2 = false,
  showItemsPerPage = false,
  options = [],
  handleSelect = () => {},
  selectedOption = null,
  placeholder = "Select or search",
  backgroundColor = "#f9f9f9",
  platformOptions = [],
  handlePlatformSelect = () => {},
  selectedPlatform = null,
  platformLabel = "Platform",
  options2 = [],
  handleSelect2 = () => {},
  selectedOption2 = null,
  placeholder2 = "Select or search",
  backgroundColor2 = "#f9f9f9",
  label2 = "Store",
  searchPlaceHolder = "Search",
  searchQuery = "",
  handleSearch = () => {},
  orderStatuses = "",
  activeTab = "",
  setActiveTab = "",
  setSelectedSort = "",
  sortOrders = "",
  selectedSort = "",
  selectedDate = "",
  handleDateChange = "",
  dateFrom = "",
  onDateFromChange = () => {},
  dateTo = "",
  onDateToChange = () => {},
  showDateRangeForActivity = false,
  startDate = "",
  endDate = "",
  onStartDateChange = () => {},
  onEndDateChange = () => {},
  viewMode = "list",
  handleViewChange = () => {},
  button1OnClick = () => {},
  button1Text,
  button2OnClick = () => {},
  button2Text,
  itemsPerPage,
  handleItemsPerPageChange,
  // Right-side toggle switch
  showRightToggle = false,
  rightToggleChecked = false,
  rightToggleOnChange = () => {},
  rightToggleLabel,
  rightToggleTitle,
  rightToggleSubtitle,
  // Dashboard specific styling control
  hideIcons = false,
  fromManageBranches = false,
  showDeliveryFilter = false,
  deliveryOptions = [],
  selectedServices = [],
  onChangeSelectedServices = () => {},
  showOperationFilter = false,
  operationOptions = [],
  selectedOperations = [],
  onChangeSelectedOperations = () => {},
  showOrderStatusFilter = false,
  orderStatusOptions = [],
  selectedOrderStatuses = [],
  onChangeSelectedOrderStatuses = () => {},
  showLogTypeFilter = false,
  logTypeOptions = [],
  selectedLogTypes = [],
  onChangeSelectedLogTypes = () => {},
  rightToggleDisabled = false,
  rightToggleTooltip = "",
  // Dashboard specific styling control
  noShadow = false,
  noPadding = false,
  showRightBtnForUsers = false,
  rightBtnTextForUsers = "",
  rightBtnOnClickForUsers = () => {},
  rightBtnClassForUsers = "primary",
  rightBtnIconForUsers = "plus",
  // Generic extra dropdowns rendered in order
  extraDropdowns = [],
  // Right-side button
  showRightBtn = false,
  rightBtnText,
  rightBtnOnClick = () => {},
  rightBtnIcon,
  rightBtnClass = "primary",
  hideSearchIcon = false,
  branchLabel,
  showBranchIcon = true,
  searchFirst = false,
  platformAfterDates = false,
  sourceComponent = null,
  toolbarVariant = null,
}) => {
  const { t, i18n } = useTranslation("translation");
  const isRTL = i18n.language === "ar" || i18n.dir() === "rtl";
  const [showDeliveryDropdown, setShowDeliveryDropdown] = useState(false);
  const [showOperationDropdown, setShowOperationDropdown] = useState(false);
  const [showOrderStatusDropdown, setShowOrderStatusDropdown] = useState(false);
  const [showLogTypeDropdown, setShowLogTypeDropdown] = useState(false);
  const deliveryDropdownRef = useRef(null);
  const toggleDeliveryDropdown = () => {
    setShowDeliveryDropdown((prev) => !prev);
  };
  const handleServiceToggle = (service) => {
    const next = selectedServices.includes(service)
      ? selectedServices.filter((s) => s !== service)
      : [...selectedServices, service];
    onChangeSelectedServices(next);
  };
  const handleOperationToggle = (op) => {
    const next = selectedOperations.includes(op)
      ? selectedOperations.filter((o) => o !== op)
      : [...selectedOperations, op];
    onChangeSelectedOperations(next);
  };
  const handleOrderStatusToggle = (st) => {
    const next = selectedOrderStatuses.includes(st)
      ? selectedOrderStatuses.filter((s) => s !== st)
      : [...selectedOrderStatuses, st];
    onChangeSelectedOrderStatuses(next);
  };
  const handleLogTypeToggle = (lt) => {
    const next = selectedLogTypes.includes(lt)
      ? selectedLogTypes.filter((s) => s !== lt)
      : [...selectedLogTypes, lt];
    onChangeSelectedLogTypes(next);
  };

  const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
  const formatOperationLabel = (op) => {
    const key = `operations.${op}`;
    const translated = t(key);
    if (translated && translated !== key) return translated;
    const map = {
      order_created: "Order Created",
      order_updated: "Order Updated",
      order_cancelled: "Order Cancelled",
      webhook_received: "Webhook Received",
      webhook_processed: "Webhook Processed",
    };
    if (map[op]) return map[op];
    return op.split("_").map(capitalize).join(" ");
  };
  const formatLogTypeLabel = (lt) => {
    const key = `logTypes.${lt}`;
    const translated = t(key);
    if (translated && translated !== key) return translated;
    const map = { log: "Log", warn: "Warning", error: "Error", fatal: "Fatal" };
    return map[lt] || lt;
  };
  const formatDeliveryService = (service) => {
    const key = `deliveryServices.${service}`;
    const translated = t(key);
    return translated && translated !== key ? translated : service;
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        deliveryDropdownRef.current &&
        !deliveryDropdownRef.current.contains(event.target)
      ) {
        setShowDeliveryDropdown(false);
      }
      if (!event.target.closest(".custom-filter-wrapper")) {
        setShowOperationDropdown(false);
        setShowOrderStatusDropdown(false);
        setShowLogTypeDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const platformDropdownBlock = showPlatformDropdown && (
    <FilterDropdown
      className="flex-item"
      orderStatuses={platformOptions}
      activeTab={selectedPlatform}
      setActiveTab={handlePlatformSelect}
      onSelectItem={handlePlatformSelect}
      showLabel={true}
      label={platformLabel}
      hideIcons={hideIcons}
    />
  );

  const searchBlock = showSearch && (
    <div className="custom-input-wrapper flex-item">
      <label
        htmlFor="orders-search-input"
        className="oh-field__label custom-input-label"
      >
        {!hideSearchIcon && !hideIcons && (
          <i className="bi bi-search oh-filter-bar__icon" aria-hidden="true" />
        )}
        {t("toolBar.search")}
      </label>
      <input
        id="orders-search-input"
        type="text"
        placeholder={t(searchPlaceHolder)}
        value={searchQuery}
        onChange={handleSearch}
        className="oh-field__control"
      />
    </div>
  );

  const allBranchOption = {
    _id: "all",
    name: toolbarVariant === "orders" ? t("all", "All") : t("allBranches", "All Branches"),
  };

  const branchBlock = showBranchDropdown && (
    branchWithAllOption ? (
      <CustomDropdown
        className="flex-item oh-toolbar-branch"
        options={options.map((branch) => ({
          ...branch,
          name:
            branch.displayName ||
            (i18n.language === "ar"
              ? branch?.name?.ar || branch?.name_ar || branch?.name?.en || branch?.name
              : branch?.name?.en || branch?.name),
        }))}
        selectedOption={selectedOption}
        handleSelect={(option) => {
          if (!option?._id || option._id === "all") {
            handleSelect(null);
          } else {
            handleSelect(option);
          }
        }}
        placeholder={allBranchOption.name}
        label={branchLabel || t("branches")}
        labelIcon="branch"
        showIcon={showBranchIcon && !hideIcons}
        showClear={true}
      />
    ) : (
      <CustomDropdown
        className="flex-item"
        options={options}
        handleSelect={handleSelect}
        selectedOption={selectedOption}
        placeholder={placeholder}
        backgroundColor={backgroundColor}
        label={branchLabel}
        showLable={!!branchLabel}
        showIcon={showBranchIcon && !hideIcons}
        labelIcon="branch"
      />
    )
  );

  const dateRangeBlock = showDateRange && (
    <>
      <div className="custom-input-wrapper flex-item">
        <span className="oh-field__label custom-input-label">
          {!hideIcons && (
            <i className="bi bi-calendar-event oh-filter-bar__icon" aria-hidden="true" />
          )}
          {t("toolBar.dateFrom")}
        </span>
        <LocalizedDateInput
          value={dateFrom}
          onChange={onDateFromChange}
          maxDate={dateTo || null}
        />
      </div>
      <div className="custom-input-wrapper flex-item">
        <span className="oh-field__label custom-input-label">
          {!hideIcons && (
            <i className="bi bi-calendar-event oh-filter-bar__icon" aria-hidden="true" />
          )}
          {t("toolBar.dateTo")}
        </span>
        <LocalizedDateInput
          value={dateTo}
          onChange={onDateToChange}
          minDate={dateFrom || null}
        />
      </div>
    </>
  );

  const statusFilterBlock = showFilter && (
    <FilterDropdown
      orderStatuses={orderStatuses}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      className="flex-item"
      hideIcons={hideIcons}
      showLabel={true}
      label={t("status")}
    />
  );

  const toolbarClass = [
    "toolbar-container",
    "oh-filter-bar",
    noShadow || sourceComponent === "AddOnIntegration" ? "toolbar-container--flat" : "",
    sourceComponent === "AddOnIntegration" ? "toolbar-container--addon" : "",
    fromManageBranches ? "toolbar-container--manage-branches" : "",
    toolbarVariant === "orders" || toolbarVariant === "shipments"
      ? "toolbar-container--orders"
      : "",
    toolbarVariant === "shipments" ? "toolbar-container--shipments" : "",
    toolbarVariant === "user-management"
      ? "toolbar-container--user-management"
      : "",
    toolbarVariant === "dashboard" ? "toolbar-container--dashboard" : "",
    toolbarVariant === "reports" || toolbarVariant === "addon-integration"
      ? "toolbar-container--reports"
      : "",
  ]
    .filter(Boolean)
    .join(" ");

  const extraDropdownNodes =
    Array.isArray(extraDropdowns) &&
    extraDropdowns.map((dd, idx) => {
      let dropdown;

      if (dd.type === "date-range") {
        dropdown = (
          <CustomDateRangePicker
            className={dd.label ? "" : "flex-item"}
            value={dd.value}
            onChange={dd.onChange}
            placeholder={dd.placeholder}
            disabled={dd.disabled}
          />
        );
      } else if (dd.type === "filter") {
        dropdown = (
          <FilterDropdown
            className={dd.label ? "" : "flex-item"}
            orderStatuses={dd.orderStatuses || []}
            activeTab={dd.activeTab}
            setActiveTab={dd.setActiveTab}
            onSelectItem={dd.onSelectItem}
            hideIcons={hideIcons}
            showLabel={false}
            label={dd.label}
          />
        );
      } else {
        dropdown = (
          <CustomDropdown
            key={idx}
            className={dd.label ? "" : "flex-item"}
            options={dd.options || []}
            handleSelect={dd.handleSelect || (() => {})}
            selectedOption={dd.selectedOption || null}
            placeholder={dd.placeholder || "Select"}
            backgroundColor={dd.backgroundColor || "#f9f9f9"}
            disabled={dd.disabled || false}
            emptyMessage={dd.emptyMessage}
            onSearchChange={dd.onSearchChange}
            showClear={dd.showClear !== undefined ? dd.showClear : true}
            showLable={false}
            showIcon={false}
          />
        );
      }

      if (dd.label) {
        return (
          <div
            key={idx}
            className={`custom-input-wrapper flex-item${
              dd.type === "date-range" ? " custom-input-wrapper--wide" : ""
            }`}
          >
            <label className="oh-field__label custom-input-label">{dd.label}</label>
            {dropdown}
          </div>
        );
      }
      if (dd.type === "date-range") {
        return (
          <div
            key={idx}
            className="flex-item custom-input-wrapper--wide"
          >
            {dropdown}
          </div>
        );
      }
      return dropdown;
    });

  return (
    <>
      <div className={toolbarClass} dir={isRTL ? "rtl" : "ltr"}>
        <div className="toolbar-main-content">
          <div className="toolbar-left-controls">
            {toolbarVariant === "orders" ? (
              <>
                {dateRangeBlock}
                {searchBlock}
                {branchBlock}
                {platformDropdownBlock}
                {statusFilterBlock}
              </>
            ) : toolbarVariant === "shipments" ? (
              <>
                {searchBlock}
                {extraDropdownNodes}
              </>
            ) : (
              <>
            {searchFirst && searchBlock}

            {branchBlock}

            {!platformAfterDates && platformDropdownBlock}

            {showDropDown2 && (
              <CustomDropdown
                className="flex-item"
                options={options2}
                handleSelect={handleSelect2}
                selectedOption={selectedOption2}
                placeholder={placeholder2}
                backgroundColor={backgroundColor2}
                label={label2}
                labelIcon="store"
                showIcon={!hideIcons}
              />
            )}

            { !searchFirst && searchBlock }
            {showDateRangeForActivity && (
              <>
                <div className="custom-input-wrapper">
                  <label
                    htmlFor="orders-start-date"
                    className="oh-field__label custom-input-label"
                  >
                    <i className="bi bi-calendar-event oh-filter-bar__icon" aria-hidden="true" />
                    {t("startDate")}
                  </label>
                  <input
                    id="orders-start-date"
                    type="date"
                    value={startDate}
                    onChange={(e) => onStartDateChange(e.target.value)}
                    className="oh-field__control custom-date"
                  />
                </div>
                <div className="custom-input-wrapper">
                  <label
                    htmlFor="orders-end-date"
                    className="oh-field__label custom-input-label"
                  >
                    <i className="bi bi-calendar-event oh-filter-bar__icon" aria-hidden="true" />
                    {t("endDate")}
                  </label>
                  <input
                    id="orders-end-date"
                    type="date"
                    value={endDate}
                    onChange={(e) => onEndDateChange(e.target.value)}
                    className="oh-field__control custom-date"
                  />
                </div>
              </>
            )}

            {showDateFilter && (
              <div className="custom-input-wrapper">
                <label
                  htmlFor="orders-date-filter"
                  className="oh-field__label custom-input-label"
                >
                  <i className="bi bi-calendar-event oh-filter-bar__icon" aria-hidden="true" />
                  {t("toolBar.date")}
                </label>
                <LocalizedDateInput
                  value={selectedDate}
                  onChange={handleDateChange}
                />
              </div>
            )}

            {dateRangeBlock}

            {platformAfterDates && platformDropdownBlock}

            {statusFilterBlock}
              </>
            )}

            {showDeliveryFilter && (
              <div className="custom-filter-wrapper" ref={deliveryDropdownRef}>
                <label className="custom-filter-label">
                  <i className={`bi bi-truck ${isRTL ? "ms-1" : "me-1"}`}></i>
                  {t("delivery")}
                </label>
                <button
                  type="button"
                  className="custom-filter-button"
                  onClick={toggleDeliveryDropdown}
                >
                  <span className="custom-filter-button-text">
                    {(() => {
                      if (!selectedServices || selectedServices.length === 0)
                        return t("Select status");
                      if (
                        deliveryOptions &&
                        selectedServices.length === deliveryOptions.length
                      )
                        return t("all");
                      if (selectedServices.length <= 3)
                        return selectedServices
                          .map(formatDeliveryService)
                          .join(", ");
                      return `${selectedServices
                        .slice(0, 3)
                        .map(formatDeliveryService)
                        .join(", ")} +${selectedServices.length - 3}`;
                    })()}
                  </span>
                  <i
                    className={`bi bi-chevron-down toolbar-dropdown-icon ${
                      showDeliveryDropdown ? "toolbar-dropdown-icon-rotate" : ""
                    }`}
                  ></i>
                </button>
                {showDeliveryDropdown && (
                  <div className="custom-filter-menu">
                    {deliveryOptions.map((service) => (
                      <div key={service} className="checkbox-item">
                        <input
                          type="checkbox"
                          id={`service-${service}`}
                          checked={selectedServices.includes(service)}
                          onChange={() => handleServiceToggle(service)}
                        />
                        <label htmlFor={`service-${service}`}>
                          {formatDeliveryService(service)}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {showOperationFilter && (
              <div className="custom-filter-wrapper">
                <label className="custom-filter-label">
                  <i className={`bi bi-gear ${isRTL ? "ms-1" : "me-1"}`}></i>
                  {t("operationType")}
                </label>
                <button
                  type="button"
                  className="custom-filter-button"
                  onClick={() => setShowOperationDropdown((prev) => !prev)}
                >
                  <span className="custom-filter-button-text">
                    {(() => {
                      if (
                        !selectedOperations ||
                        selectedOperations.length === 0
                      )
                        return t("Select status");
                      if (
                        operationOptions &&
                        selectedOperations.length === operationOptions.length
                      )
                        return t("all");
                      if (selectedOperations.length <= 3)
                        return selectedOperations
                          .map(formatOperationLabel)
                          .join(", ");
                      const firstThree = selectedOperations
                        .slice(0, 3)
                        .map(formatOperationLabel)
                        .join(", ");
                      return `${firstThree} +${selectedOperations.length - 3}`;
                    })()}
                  </span>
                  <i
                    className={`bi bi-chevron-down toolbar-dropdown-icon ${
                      showOperationDropdown
                        ? "toolbar-dropdown-icon-rotate"
                        : ""
                    }`}
                  ></i>
                </button>
                {showOperationDropdown && (
                  <div className="custom-filter-menu">
                    {operationOptions.map((op) => (
                      <div key={op} className="checkbox-item">
                        <input
                          type="checkbox"
                          id={`op-${op}`}
                          checked={selectedOperations.includes(op)}
                          onChange={() => handleOperationToggle(op)}
                        />
                        <label htmlFor={`op-${op}`}>
                          {formatOperationLabel(op)}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {showSort && (
              <SortDropdown
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
                sortOrders={sortOrders}
                className="flex-item"
                hideIcon={hideIcons}
              />
            )}

            {showOrderStatusFilter && (
              <div className="custom-filter-wrapper">
                <label className="custom-filter-label">
                  <i
                    className={`bi bi-list-check ${isRTL ? "ms-1" : "me-1"}`}
                  ></i>
                  {t("orderStatus")}
                </label>
                <button
                  type="button"
                  className="custom-filter-button"
                  onClick={() => setShowOrderStatusDropdown((prev) => !prev)}
                >
                  <span className="custom-filter-button-text">
                    {(() => {
                      if (
                        !selectedOrderStatuses ||
                        selectedOrderStatuses.length === 0
                      )
                        return t("Select status");
                      if (
                        orderStatusOptions &&
                        selectedOrderStatuses.length ===
                          orderStatusOptions.length
                      )
                        return t("all");
                      const formatLabel = (s) => t(`statuses.${s}`);
                      if (selectedOrderStatuses.length <= 3)
                        return selectedOrderStatuses
                          .map(formatLabel)
                          .join(", ");
                      const firstThree = selectedOrderStatuses
                        .slice(0, 3)
                        .map(formatLabel)
                        .join(", ");
                      return `${firstThree} +${
                        selectedOrderStatuses.length - 3
                      }`;
                    })()}
                  </span>
                  <i
                    className={`bi bi-chevron-down toolbar-dropdown-icon ${
                      showOrderStatusDropdown
                        ? "toolbar-dropdown-icon-rotate"
                        : ""
                    }`}
                  ></i>
                </button>
                {showOrderStatusDropdown && (
                  <div className="custom-filter-menu">
                    {orderStatusOptions.map((st) => (
                      <div key={st} className="checkbox-item">
                        <input
                          type="checkbox"
                          id={`st-${st}`}
                          checked={selectedOrderStatuses.includes(st)}
                          onChange={() => handleOrderStatusToggle(st)}
                        />
                        <label htmlFor={`st-${st}`}>
                          {t(`statuses.${st}`)}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {showLogTypeFilter && (
              <div className="custom-filter-wrapper">
                <label className="custom-filter-label">
                  <i className={`bi bi-funnel ${isRTL ? "ms-1" : "me-1"}`}></i>
                  {t("logsType")}
                </label>
                <button
                  type="button"
                  className="custom-filter-button"
                  onClick={() => setShowLogTypeDropdown((prev) => !prev)}
                >
                  <span className="custom-filter-button-text">
                    {(() => {
                      if (!selectedLogTypes || selectedLogTypes.length === 0)
                        return t("Select status");
                      if (
                        logTypeOptions &&
                        selectedLogTypes.length === logTypeOptions.length
                      )
                        return t("all");
                      if (selectedLogTypes.length <= 3)
                        return selectedLogTypes
                          .map(formatLogTypeLabel)
                          .join(", ");
                      const firstThree = selectedLogTypes
                        .slice(0, 3)
                        .map(formatLogTypeLabel)
                        .join(", ");
                      return `${firstThree} +${selectedLogTypes.length - 3}`;
                    })()}
                  </span>
                  <i
                    className={`bi bi-chevron-down toolbar-dropdown-icon ${
                      showLogTypeDropdown ? "toolbar-dropdown-icon-rotate" : ""
                    }`}
                  ></i>
                </button>
                {showLogTypeDropdown && (
                  <div className="custom-filter-menu">
                    {logTypeOptions.map((lt) => (
                      <div key={lt} className="checkbox-item">
                        <input
                          type="checkbox"
                          id={`lt-${lt}`}
                          checked={selectedLogTypes.includes(lt)}
                          onChange={() => handleLogTypeToggle(lt)}
                        />
                        <label htmlFor={`lt-${lt}`}>
                          {formatLogTypeLabel(lt)}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {showItemsPerPage && (
              <ItemsPerPageDropdown
                itemsPerPage={itemsPerPage}
                onChange={handleItemsPerPageChange}
                className="flex-item"
              />
            )}

            {toolbarVariant !== "shipments" && extraDropdownNodes}

            {showButton1 && (
              <Button
                color="primary"
                size="sm"
                onClick={button1OnClick}
                style={{
                  whiteSpace: "nowrap",
                  width: "fit-content",
                }}
              >
                {button1Text}
              </Button>
            )}

            {showButton2 && (
              <Button
                color="primary"
                size="sm"
                onClick={button2OnClick}
                style={{
                  whiteSpace: "nowrap",
                  width: "fit-content",
                }}
              >
                {button2Text}
              </Button>
            )}
          </div>
          {(showViewMode || showRightToggle || showRightBtnForUsers || showRightBtn ) && (
            <div className="view-toggle-wrapper" style={{ gap: 12 }}>
              {showViewMode && (
                <ViewToggleDropdown
                  viewMode={viewMode}
                  onViewChange={handleViewChange}
                  showViewMode={showViewMode}
                />
              )}
              {showRightToggle && (
                rightToggleDisabled && rightToggleTooltip ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="toggle-tooltip">{rightToggleTooltip}</Tooltip>}
                  >
                    <div className={`toolbar-switch ${rightToggleDisabled ? "toolbar-switch-disabled" : ""}`}>
                      {(rightToggleTitle || rightToggleLabel) && (
                        <div className="switch-text">
                          <span className={`switch-title ${rightToggleDisabled ? "disabled-text" : ""}`}>
                            {rightToggleTitle || rightToggleLabel}
                          </span>
                          {rightToggleSubtitle && (
                            <span className="switch-subtitle">{rightToggleSubtitle}</span>
                          )}
                        </div>
                      )}
                      <label className={`toggle ${rightToggleDisabled ? "toggle-disabled" : ""}`}>
                        <input
                          type="checkbox"
                          checked={rightToggleChecked}
                          onChange={(e) => !rightToggleDisabled && rightToggleOnChange?.(e.target.checked)}
                          disabled={rightToggleDisabled}
                        />
                        <span className="slider"></span>
                      </label>
                    </div>
                  </OverlayTrigger>
                ) : (
                  <div className={`toolbar-switch ${rightToggleDisabled ? "toolbar-switch-disabled" : ""}`}>
                    {(rightToggleTitle || rightToggleLabel) && (
                      <div className="switch-text">
                        <span className={`switch-title ${rightToggleDisabled ? "disabled-text" : ""}`}>
                          {rightToggleTitle || rightToggleLabel}
                        </span>
                        {rightToggleSubtitle && (
                          <span className="switch-subtitle">{rightToggleSubtitle}</span>
                        )}
                      </div>
                    )}
                    <label className={`toggle ${rightToggleDisabled ? "toggle-disabled" : ""}`}>
                      <input
                        type="checkbox"
                        checked={rightToggleChecked}
                        onChange={(e) => !rightToggleDisabled && rightToggleOnChange?.(e.target.checked)}
                        disabled={rightToggleDisabled}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                )
              )}
              {showRightBtn && (
                <Button
                  color={rightBtnClass === "ocean" ? "primary" : rightBtnClass}
                  onClick={rightBtnOnClick}
                  size="md"
                  style={{
                    whiteSpace: "nowrap",
                    width: "fit-content",
                  }}
                  icon={rightBtnIcon === "plus" ? <i className="bi bi-plus-lg" /> : null}
                >
                  {rightBtnText}
                </Button>
              )}
              {showRightBtnForUsers && ( 
                <Button
                color={rightBtnClassForUsers === "ocean" ? "primary" : rightBtnClassForUsers}
                onClick={rightBtnOnClickForUsers}
                style={{
                  height: "44px",
                  whiteSpace: "nowrap",
                  width: "fit-content",
                  padding: "0 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {rightBtnIconForUsers === "plus" && <i className="bi bi-plus-lg fs-5"></i>}
                {rightBtnTextForUsers}
              </Button>
               )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Toolbar;